import EventBus from '@/components/mixins/event-bus-mixin'

export default {
  name: 'mainLoader',
  data () {
    return {
      isVisible: false,
      hasBackground: false,
      textLabel: ''
    }
  },
  methods: {
    handleVisibility () {
      // Listen from Global Event Bus
      const thisComponent = this
      EventBus.$on('MAIN_LOADER_VISIBILE', (payLoad) => {
        thisComponent.isVisible = payLoad.isVisible
        thisComponent.textLabel = payLoad?.label ?? this.$t('label.loading')
        thisComponent.hasBackground = payLoad?.hasBackground ?? false
      })
    }
  },
  mounted () {
    this.handleVisibility()
  }
}
